import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { DebounceInput } from 'react-debounce-input';
import InputMask from "react-input-mask";

import Utils from '../../../Services/Utils';

import withShallowComparison from '../../Common/withShallowComparisonUpdate';
import InputWrapper from '../WrapperInput';

import './style.scss';
import Icon from "../../Common/Icon";
import {ReactComponent as SearchIcon} from "../../../../img/icon-search.svg";
import ConfigService from "../../../Services/api/Config";
import $ from "../../../../offline/jquery.min";

class InputText extends React.PureComponent {

  constructor(props) {
    super(props);
    this.textInput = React.createRef();
  }

  componentDidMount() {
    this.initValidate();
  }

  componentDidUpdate() {
    this.initValidate();
  }

  initValidate = () => {
    const { value, onError, error } = this.props;
    const newError = this.validate(value);
    if (onError && !Utils.equals(newError, error)) onError(newError);
  }

  validate = (value) => {
    const { required, validators, maxlength, minlength, patterntext, patterntexterror } = this.props;
    if (required && Utils.isNull(value)) return 'This field is required.';
    if (maxlength && (!Utils.isNull(value) && (value.length > parseInt(maxlength)))) {
      return 'This field must have a maximum of ' + maxlength + ' characters';
    }
    if (minlength && (!Utils.isNull(value) && (value.length < parseInt(minlength)))) {
      return 'This field must have a minimum of ' + minlength + ' characters';
    }
    if (patterntext && (!Utils.isNull(value) && (!patterntext.test(value)))) return patterntexterror;
    for (const validator of validators || []) {
      if (validator(value)) return validator(value);
    }
    return '';
  };

  handleChange = (e) => {
    const { onChange, onError, error } = this.props;
    const value = e && e.target ? e.target.value : e;
    if (onChange) onChange(value);
    const newError = this.validate(value);
    if (onError && !Utils.equals(newError, error)) onError(newError);
  };

  handleKeyDown = (e) => {
    const { onSubmit, maxlength } = this.props;
    if (e.keyCode !== 8) {
      if (e.keyCode === 13) {
        if (onSubmit) onSubmit(e);
        e.preventDefault();
      }
      else {
        if ($(this.textInput.current).val().toString().length === parseInt(maxlength)) {
          if (e.keyCode !== 9) {
            e.preventDefault();
          }
        }
      }
    }
  };

  render() {
    const {
      className,
      label,
      labelhtml,
      error,
      placeholder,
      disabled,
      required,
      value,
      disablechange,
      mask,
      debounce,
      onChange,
      onBlur,
      onClick,
      onFocus,
      onKeyDown,
      readOnly,
      notShowErrors
    } = this.props;

    const WrapperProps = {
      className,
      label,
      labelhtml,
      error,
      required,
      notShowErrors
    };

    const debounceTimeout = !Utils.isNull(debounce) ? debounce : 500;

    const changeProps = {
      onChange: onChange,
      onFocus: onFocus,
      onBlur: onBlur,
      onClick: onClick,
      onKeyDown: onKeyDown,
    };
    if (!disablechange) {
      changeProps['onChange'] = this.handleChange;
    }

    var search = className ? className.includes('Input-Search') : false;
    
    return (
      <InputWrapper { ...WrapperProps }>
        { search &&
          <Icon position='Left' width='16' height='16' color={ ConfigService.getColor('tertiaryColor') }>
            <SearchIcon alt='icon-search'/>
          </Icon>
        }
        { mask &&
          <DebounceInput
            inputRef={ this.textInput }
            debounceTimeout={ debounceTimeout }
            element={ InputMask }
            readOnly={ readOnly }
            mask={ mask }
            value={ !Utils.isNull(value) ? value : '' }
            disabled={ disabled }
            required={ required }
            {...changeProps}
            onKeyDown={ this.handleKeyDown }
            className={ classNames('InputText', {
              InputText_Disabled: Boolean(disabled),
            }) }
            maskPlaceholder={ placeholder }
          />
          ||
          <DebounceInput
            inputRef={ this.textInput }
            debounceTimeout={ debounceTimeout }
            value={ !Utils.isNull(value) ? value : '' }
            disabled={ disabled }
            readOnly={ readOnly }
            required={ required }
            {...changeProps}
            onKeyDown={ this.handleKeyDown }
            className={ classNames('InputText', {
              InputText_Disabled: Boolean(disabled),
            }) }
            placeholder={ placeholder }
          />
        }
      </InputWrapper>
    );
  }
}

InputText.propTypes = {
  className: PropTypes.string,
  mask: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  validators: PropTypes.array,
  error: PropTypes.string,
  minlength: PropTypes.string,
  maxlength: PropTypes.string,
  placeholder: PropTypes.string,
  patterntext: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  patterntexterror: PropTypes.string,
  debounce: PropTypes.number,
  notShowErrors: PropTypes.bool,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  onError: PropTypes.func,
  disablechange: PropTypes.string
};

export default withShallowComparison(InputText, ['onChange', 'onError']);